import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getHomePath } from '~/utils/routes/home';
import { getAppRole } from '~/utils/helper/role';
import { authActions } from '~/thunks/auth/authSlice';
import { SignInComponent } from '~/components/module/auth';
import { useAppDispatch } from '~/utils/redux/hooks';
import { handleLogin as handleLoginThunk } from '~/thunks/auth/authThunk';
import { LoginTypeEnum } from '~/utils/enum/common';
import images from '~/assets/images';

const SignIn = () => {
  //#region Declare Hook
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  //#endregion Declare Hook

  //#region Declare State
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  //#endregion Declare State

  //#region Handle Function
  const handleLogin = async (payload: { account: string; password: string }) => {
    setLoading(true);
    setErrorMessage('');

    const result = await dispatch(
      handleLoginThunk({
        body: { type: LoginTypeEnum.STANDARD, account: payload.account, password: payload.password },
      })
    );

    setLoading(false);

    if (handleLoginThunk.fulfilled.match(result)) {
      const account = result.payload?.data?.account;
      const role = getAppRole(account);
      if (!role || role === 'contact') {
        dispatch(authActions.handleLogout());
        setErrorMessage(t('auth.signIn.errorNoWebAccess'));
        return;
      }
      navigate(getHomePath(role));
      return;
    }

    setErrorMessage(t('auth.signIn.errorInvalidCredentials'));
  };
  //#endregion Handle Function

  return (
    <div id='signInPageAdmin' className='min-h-screen w-full bg-background lg:flex lg:h-screen lg:overflow-hidden'>
      <div className='relative hidden w-1/2 lg:block'>
        <img
          src={images.adminBackgroundImageLogin}
          alt={t('auth.signIn.heroAlt')}
          className='h-full w-full object-cover'
        />
        <div className='absolute inset-0 bg-gradient-to-t from-primary/80 via-primary/20 to-transparent' />
      </div>

      <div className='flex min-h-screen min-w-0 flex-1 flex-col items-center justify-center gap-6 px-4 py-8 sm:gap-8 sm:px-6 lg:min-h-0 lg:py-0'>
        <div className='aspect-[568/50] w-full max-w-[280px] shrink-0 overflow-hidden'>
          <img src={images.adminLogoSidebar} alt='SmartSeniors' className='h-full w-full object-contain' />
        </div>
        <SignInComponent loading={loading} errorMessage={errorMessage} onSubmit={handleLogin} />
      </div>
    </div>
  );
};

export default SignIn;
